import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {CircleWarningIcon} from 'shells/icon/svg/circle-warning-icon';
import {Body} from 'shells/typography/body';

type Props = {
    title: string;
    errorMessage: string;
    tooltipText: string;
};

export function CalendarTitleWithSyncError(props: Props) {
    return (
        <div className='flex align-center justify-center gap-8'>
            {props.title}
            <div
                className='flex align-center gap-4'
                data-tip={props.tooltipText}
                data-effect='solid'
            >
                {/* @ts-expect-error */}
                <CircleWarningIcon color={colors.error} size={14} />
                <Body size='small' color='error'>
                    {props.errorMessage}
                </Body>
            </div>
        </div>
    );
}
